import React from 'react';
import {
  Box,
  Container,
  Typography,
  Link,
  Grid,
  IconButton,
} from '@mui/material';
import {
  LinkedIn,
  Facebook,
  Instagram,
  Email,
} from '@mui/icons-material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#000000',
        color: '#ffffff',
        py: 4,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} justifyContent="space-between" alignItems="center">
          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ color: '#db4481', fontWeight: 'bold' }}>
              StudioGo
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
              Beyond amazing
            </Typography>
          </Grid>

          {/* Contact Link */}
          <Grid item xs={12} md={4} sx={{ textAlign: 'center' }}>
            <Link
              href="mailto:hello@chloejackman.com"
              color="inherit"
              underline="hover"
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                fontSize: '1.1rem',
                '&:hover': {
                  color: '#db4481',
                },
              }}
            >
              <Email />
              Contact Us
            </Link>
          </Grid>

          {/* Social Media Links */}
          <Grid item xs={12} md={4} sx={{ textAlign: 'right' }}>
            <Typography variant="body2" gutterBottom sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
              Follow us on:
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
              <IconButton
                href="https://www.instagram.com/studiogophoto/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: '#ffffff',
                  '&:hover': {
                    color: '#db4481',
                    backgroundColor: 'rgba(219, 68, 129, 0.1)',
                  },
                }}
              >
                <Instagram />
              </IconButton>
              <IconButton
                href="https://linkedin.com/company/studiogo"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: '#ffffff',
                  '&:hover': {
                    color: '#db4481',
                    backgroundColor: 'rgba(219, 68, 129, 0.1)',
                  },
                }}
              >
                <LinkedIn />
              </IconButton>
              <IconButton
                href="https://facebook.com/studiogophoto"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: '#ffffff',
                  '&:hover': {
                    color: '#db4481',
                    backgroundColor: 'rgba(219, 68, 129, 0.1)',
                  },
                }}
              >
                <Facebook />
              </IconButton>
            </Box>
          </Grid>
        </Grid>

        {/* Copyright */}
        <Box sx={{ mt: 3, pt: 2, borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}>
          <Typography
            variant="body2"
            sx={{
              color: 'rgba(255, 255, 255, 0.5)',
              textAlign: 'center',
            }}
          >
            © {new Date().getFullYear()} StudioGo. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 